import { Newspaper, ArrowSquareOut } from '@phosphor-icons/react';

export default function RssArticle({ article }) {
  const hasImage = !!article.image;

  return (
    <div className="feed-rss-item" data-testid={`rss-article-${article.article_id}`}>
      {/* Background: image or golf-themed gradient */}
      {hasImage ? (
        <img
          src={article.image}
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
          style={{ zIndex: 1 }}
          loading="lazy"
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      ) : (
        <div
          className="absolute inset-0"
          style={{
            zIndex: 1,
            background: 'linear-gradient(135deg, #0B3D1B 0%, #1B4332 30%, #2D6A4F 60%, #40916C 100%)',
          }}
        />
      )}

      {/* Gradient overlay for text readability */}
      <div
        className="absolute inset-0"
        style={{
          zIndex: 2,
          background: hasImage
            ? 'linear-gradient(to top, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.4) 40%, rgba(0,0,0,0.05) 100%)'
            : 'linear-gradient(to top, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.1) 50%, transparent 100%)',
        }}
      />

      {/* Decorative pattern for no-image articles */}
      {!hasImage && (
        <div className="absolute inset-0" style={{
          zIndex: 2,
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none'%3E%3Cg fill='%23D4AF37' fill-opacity='0.06'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          opacity: 0.5,
        }} />
      )}

      {/* Source badge */}
      <div className="absolute top-4 left-4" style={{ zIndex: 5 }}>
        <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full" style={{ background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(8px)' }}>
          <Newspaper size={12} weight="fill" className="text-[#D4AF37]" />
          <span className="text-white/90 text-[10px] font-sans font-semibold uppercase tracking-wider">
            {article.source}
          </span>
        </div>
      </div>

      {/* Content — positioned above bottom of item */}
      <div className="absolute bottom-0 left-0 right-0 px-5 pb-6 pt-5" style={{ zIndex: 5 }}>
        <h3
          className="text-white text-xl font-sans font-bold leading-snug line-clamp-3"
          style={{ textShadow: '0 2px 8px rgba(0,0,0,0.9)' }}
        >
          {article.title}
        </h3>
        {article.description && (
          <p
            className="text-white/70 text-sm font-sans mt-2.5 line-clamp-3 leading-relaxed"
            style={{ textShadow: '0 1px 4px rgba(0,0,0,0.8)' }}
          >
            {article.description}
          </p>
        )}
        <a
          href={article.link}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 mt-3 text-[#D4AF37] text-sm font-sans font-semibold uppercase tracking-wider hover:text-white transition-colors"
          data-testid={`rss-read-${article.article_id}`}
        >
          Read Article <ArrowSquareOut size={14} weight="bold" />
        </a>
      </div>
    </div>
  );
}
